import React from 'react'
import SearchUI from '../../../widgets/input/SearchUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import ButtonUI from '../../../widgets/action/ButtonUI'
import './AlertList.css'

const AlertListUI = ({ context, messageList, alertList,
  searchFilter, onRefreshClick, onDismissClick, onSearchFilterChange,
  onUpdateDueDateClick, onSendReminderClick, onAllocateClick
}) =>
  <div className='c_alerts'>

    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          onRefreshClick={onRefreshClick}
        />
      }
      right={
        <ActionTopRightUI
          context={context}
          messageList={messageList}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />
    <div>
      {
        alertList.map((alert, i) =>
          <AlertRowUI key={i} context={context} messageList={messageList} alert={alert}
            onDismissClick={onDismissClick} onUpdateDueDateClick={onUpdateDueDateClick}
            onSendReminderClick={onSendReminderClick} onAllocateClick={onAllocateClick}/>
        )
      }
    </div>
  </div>

const AlertRowUI = ({ context, alert, messageList, onDismissClick, onUpdateDueDateClick, onSendReminderClick, onAllocateClick }) =>
  <div className='g_m_top_100'>
    <div className='msg'>
      {alert.message}
    </div>
    <div className='g_flex_h action'>
      <ButtonUI messageList={messageList} labelKey='c_dismiss' onClick={onDismissClick} dataId={alert.alertId} transparent={true} />
      <ButtonUI messageList={messageList} labelKey={alertActionLabelSwitch(alert.alertType)} onClick={alertActionEventHandlerSwitch(alert.alertType, onUpdateDueDateClick, onSendReminderClick, onAllocateClick)} dataId={alert.alertId} transparent={true} />
    </div>
  </div>

const alertActionEventHandlerSwitch = (alertType, onUpdateDueDateClick, onSendReminderClick, onAllocateClick) => {
  switch (alertType) {
    case 'customer_order_due_soon':
      return onUpdateDueDateClick;
    case 'customer_order_overdue':
      return onUpdateDueDateClick;
    case 'invoice_payment_overdue':
      return onSendReminderClick;
    case 'expense_incomplete':
      return null;
    case 'budget_fund_request':
      return onAllocateClick;
    case 'low_bank_balance':
      return null;
    default:
      return null;
  }
}

const alertActionLabelSwitch = (alertType) => {
  switch (alertType) {
    case 'customer_order_due_soon':
      return 'c_change_due_date';
    case 'customer_order_overdue':
      return 'c_change_due_date';
    case 'invoice_payment_overdue':
      return 'c_send_reminder';
    case 'expense_incomplete':
      return 'c_provide_details';
    case 'budget_fund_request':
      return 'c_allocate';
    case 'low_bank_balance':
      return 'c_review';
    default:
      return '';
  }
}

const ActionLeftUI = ({ context, messageList, onRefreshClick
}) =>
  <div className='g_flex_h'>
    <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
  </div>

const ActionTopRightUI = ({ context, messageList, searchFilter, onSearchFilterChange
}) =>
  <div className='g_flex_h'>
    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
  </div>

export default AlertListUI
